import { useEffect, useState } from "react";
import AddEditDirector from "./AddEditDirector";
import moment from "moment";

const Directors = ({ directors, setDirectors, directorsTypesList, swalAlert, memberId }) => {
    const initialProjectState = {
        name: "",
        nRIC_FIN_Passport: "",
        dateofAppoitment: "",
        isDirector: true,
        slotsMemberId: memberId,
        isShareHolder: false,
    };

    const [projects, setProjects] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [newProject, setNewProject] = useState(initialProjectState);
    const [editingProject, setEditingProject] = useState(null);
    const [validState, setValidState] = useState({ error: {} });

    useEffect(() => {
        if (JSON.stringify(projects) !== JSON.stringify(directors)) {
            setDirectors(projects);
        }
    }, [projects]);

    useEffect(() => {
        if (directors.length > 0) {
            setProjects(directors);
        }
    }, [directors]);

    const openModal = () => setIsOpen(true);
    const closeModal = () => {
        setIsOpen(false);
        setEditingProject(null);
        resetNewProject();
    };

    const resetNewProject = () => {
        setNewProject(initialProjectState);
    };

    const handleEdit = (id) => {
        const projectToEdit = projects.find(
            (project) => project.id === id || project.directorsAndShareholdersID === id
        );
        if (projectToEdit) {
            setEditingProject(JSON.parse(JSON.stringify(projectToEdit)));
            openModal();
        }
    };


    const handleChange = (field, value) => {
        const upperCaseValue = typeof value === 'string' ? value.toUpperCase() : value;

        if (editingProject) {
            setEditingProject((prev) => ({ ...prev, [field]: upperCaseValue }));
        } else {
            setNewProject((prev) => ({ ...prev, [field]: upperCaseValue }));
        }
    };


    const handleDelete = (id) => {
        setProjects((prevProjects) => prevProjects.filter((project) => project.id !== id && project.directorsAndShareholdersID !== id));
    };

    const handleSave = () => {
        const minDate = moment("1753-01-01");
        const maxDate = moment("9999-12-31");

        let errors = {};

        const projectToValidate = editingProject || newProject;

        if (!projectToValidate.name?.trim()) {
            errors.name = "Name is required.";
        }

        if (!projectToValidate.nRIC_FIN_Passport?.trim()) {
            errors.nRIC_FIN_Passport = "NRIC/FIN/Passport is required.";
        }

        if (!projectToValidate.dateofAppoitment) {
            errors.dateofAppoitment = "Date of Appointment is required.";
        } else if (
            !moment(projectToValidate.dateofAppoitment).isBetween(minDate, maxDate, "day", "[]")
        ) {
            errors.dateofAppoitment = "Date must be between 01/01/1753 and 12/31/9999.";
        }

        if (Object.keys(errors).length > 0) {
            setValidState({ error: errors });
            return;
        }

        if (editingProject) {
            setProjects((prevProjects) =>
                prevProjects.map((project) =>
                    (project.id && editingProject.id && project.id === editingProject.id) ||
                        (project.directorsAndShareholdersID &&
                            editingProject.directorsAndShareholdersID &&
                            project.directorsAndShareholdersID === editingProject.directorsAndShareholdersID)
                        ? { ...project, ...editingProject }
                        : project
                )
            );
        } else {
            const newId =
                projects.length > 0
                    ? Math.max(...projects.map((p) => p.id || 0)) + 1
                    : 1;
            setProjects([...projects, { ...newProject, id: newId }]);
        }

        setValidState({ error: {} });
        closeModal();
    };




    return (
        <div className="project-complete">
            <div className="add-btn-sec">
                <button
                    type="button"
                    className="bg-orange-400 text-white px-4 py-2 rounded-md hover:bg-orange-600 transition duration-200 mb-4 flex items-center"
                    onClick={openModal}
                >
                    + Add
                </button>
            </div>

            <div className="w-full flex">
                <div className="w-full">
                    <table className="w-full table-fixed border">
                        <thead className="bg-[#e78e3c] text-white">
                            <tr>
                                <th className="w-1/4 px-4 py-2 text-left">Name</th>
                                <th className="w-1/4 px-4 py-2 text-left">NRIC/FIN/Passport</th>
                                <th className="w-1/4 px-4 py-2 text-left">Date Of Appointment</th>
                                <th className="w-1/4 px-4 py-2 text-left">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {projects.map((project) => (
                                <tr key={project.id || project.directorsAndShareholdersID} className="odd:bg-gray-100">
                                    <td className="w-1/4 px-4 py-2">{project.name}</td>
                                    <td className="w-1/4 px-4 py-2">{project.nRIC_FIN_Passport}</td>
                                    <td className="w-1/4 px-4 py-2">
                                        {project.dateofAppoitment ? moment(project.dateofAppoitment).format("DD-MM-YYYY") : ""}
                                    </td>
                                    <td className="w-1/4 px-4 py-2">
                                        <div className="flex gap-4">
                                            <button className="action-btn-edit mr-4" onClick={() => handleEdit(project.id || project.directorsAndShareholdersID)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
                                                    <path
                                                        fill="currentColor"
                                                        d="M20.094.25a2.25 2.25 0 0 0-1.625.656l-1 1.031l6.593 6.625l1-1.03a2.32 2.32 0 0 0 0-3.282L21.75.937A2.36 2.36 0 0 0 20.094.25m-3.75 2.594l-1.563 1.5l6.875 6.875L23.25 9.75zM13.78 5.438L2.97 16.155a.98.98 0 0 0-.5.625L.156 24.625a.975.975 0 0 0 1.219 1.219l7.844-2.313a.98.98 0 0 0 .781-.656l10.656-10.563l-1.468-1.468L8.25 21.813l-4.406 1.28l-.938-.937l1.344-4.593L15.094 6.75zm2.375 2.406l-10.968 11l1.593.343l.219 1.47l11-10.97z"
                                                    />
                                                </svg>
                                            </button>
                                            <button className="action-btn-delete mr-4" onClick={() => handleDelete(project.id || project.directorsAndShareholdersID)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                                                    <path
                                                        fill="currentColor"
                                                        d="M13.5 6.5V7h5v-.5a2.5 2.5 0 0 0-5 0m-2 .5v-.5a4.5 4.5 0 1 1 9 0V7H28a1 1 0 1 1 0 2h-1.508L24.6 25.568A5 5 0 0 1 19.63 30h-7.26a5 5 0 0 1-4.97-4.432L5.508 9H4a1 1 0 0 1 0-2zM9.388 25.34a3 3 0 0 0 2.98 2.66h7.263a3 3 0 0 0 2.98-2.66L24.48 9H7.521zM13 12.5a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1m7 1a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0z"
                                                    />
                                                </svg>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="add-edite-project-popup">
                <AddEditDirector
                    directors={directors}
                    setDirectors={setDirectors}
                    modalOpen={isOpen}
                    setModalOpen={setIsOpen}
                    editingProject={editingProject}
                    newProject={newProject}
                    isProjectCompleted={directors.isProjectCompleted}
                    handleChange={handleChange}
                    handleSave={handleSave}
                    closeModal={closeModal}
                    validState={validState} 
                />
            </div>
        </div>
    );
};

export default Directors;
